import { createSelector } from 'reselect';
import {
    get, has, filter, values, pick,
} from 'lodash';

/**
 * Base Selectors
 */
const getEntityId = (state, id) => id;
const getEntities = (state) => state.app.database.reservationHotels;
const getMetaEntities = (state) => state.app.metaDatabase.reservationHotels;
const getReservationHotelRooms = (state) => state.app.database.reservationHotelRooms;
const getReservationHotelNumbers = (state) => state.app.database.reservationHotelNumbers;
const getCurrencies = (state) => state.app.database.currencies;
/**
 * Selector Builders
 */
export const buildMetaReservationHotelSelector = () => createSelector([getEntityId, getMetaEntities], (entityId, metaEntities) =>
{
    if (has(metaEntities, entityId))
    {
        return metaEntities[entityId];
    }

    return {};
});

export const buildReservationHotelSelector = () => createSelector([getEntityId, getEntities], (entityId, entities) =>
{
    if (has(entities, entityId))
    {
        return entities[entityId];
    }

    return {};
});

export const buildReservationHotelsSelector = () => createSelector([getEntityId, getEntities], (entityIds, entities) => values(pick(entities, entityIds)));

export const buildReservationHotelsByReservationIdSelector = () => createSelector([
    getEntityId,
    getEntities,
    getReservationHotelRooms,
    getReservationHotelNumbers,
    getCurrencies,
], (reservationId, entities, reservationHotelRooms, reservationHotelNumbers, currencies) => filter(entities, { reservation_id: reservationId }).map((reservationHotel) =>
{
    const rooms = filter(reservationHotelRooms, { reservation_hotel_id: reservationHotel.id });

    return ({
        ...reservationHotel,
        reservationHotelRooms: rooms,
        numbers: get(reservationHotelNumbers, `ReservationHotel_${reservationHotel.id}_Numbers`, {}),
        currency: get(currencies, reservationHotel.currency_id, {}),
    });
}));
